// extracted by mini-css-extract-plugin
export default {"custom-table":"Table_custom-table__NvuhD"};